import React from 'react';
import Image from 'next/image';
import { IsNotMobile, isDesktop } from '../../../components/ResponsiveContainers/index.js';

import {
  AppSectionContainer,
  Title,
  ImageWrap,
  AppDetailSection,
} from './styled.js';

function AppSection() {
  return (
    <AppSectionContainer>
      <Title>Career Opportunities</Title>
      <AppDetailSection> 
        <h2 className="apply in-person">APPLY IN-PERSON</h2>
        <p className="address">5585 Wells Park Rd </p>
        <p className="address">West Jordan, UT 84081</p>
        <p className="address">8:00 AM – 5:00 PM</p>
        <p className="address click"> <a href="http://maps.google.com/?q=5585 Wells Park Rd, West Jordan, UT 84081">Click for Directions </a></p>
        <h2 className="apply online">APPLY ONLINE</h2>
        <p className="address click"> <a href="/files/Application-Classy-Closets.pdf" download>Click to Download Application </a></p>
      </AppDetailSection>
      <ImageWrap > 
        <Image 
        src={"/images/careers/featured.webp"}
        layout="fill"
        className="banner-image"
        alt="banner image"
        objectFit="cover"
        quality={60}
        />
      </ImageWrap>

    </AppSectionContainer>
  )
}

export default AppSection
